/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ApolloCache, Reference, StoreObject } from "@apollo/client";

export function removeFromApolloCache<T>(
  cache: ApolloCache<T>,
  {
    item,
    ...evictOptions
  }: Parameters<typeof cache.evict>[0] & {
    item?: Reference | StoreObject | string;
  }
) {
  cache.evict({
    ...(item ? { id: getApolloCacheEntryId(cache, item) } : {}),
    ...evictOptions,
  });
  cache.gc();
}

function getApolloCacheEntryId<T>(
  cache: ApolloCache<T>,
  item: Reference | StoreObject | string
) {
  return typeof item === "string" ? item : cache.identify(item);
}
